export default __webpack_public_path__ + "static/media/home-light.3adf038f.svg";